module.exports = __webpack_public_path__ + "static/media/settings-logo.472fb1bd.png";